import { getTime } from "utils";

function NotificationCard({ notification, handleRedirect }) {
  return (
    <div
      className={`flex flex-col gap-1 px-4 py-2.5 border-b text-sm border-gray-200 dark:border-gray-700 transition-colors duration-200 cursor-pointer ${
        !notification.isRead
          ? "bg-blue-50 hover:bg-white dark:bg-gray-800 dark:hover:dark:bg-gray-900"
          : "bg-white dark:bg-gray-900"
      }`}
      onClick={() => {
        handleRedirect(
          notification.redirectUrl,
          notification.isRead,
          notification.id
        );
      }}
    >
      <div className="flex items-center justify-between">
        <h2 className="font-bold text-black dark:text-white">
          {notification.title}
        </h2>

        <div className="text-xs text-[#737373]">
          {getTime(notification.createdAt)}
        </div>
      </div>

      <p className="text-black dark:text-white">{notification.message}</p>
    </div>
  );
}

export default NotificationCard;
